import { MediaPartnerNotices, MediaPartnerNoticesResponse } from 'types/sanity/marketing-components';
import { MediaPartnerNoticesQuery } from './queries/media-partner-notices';
import { useQuery } from 'villus';
import { villusClient } from '@utils/villus';

export async function getMediaPartnerNotices(): Promise<MediaPartnerNotices | null> {
	const { data } = await useQuery<MediaPartnerNoticesResponse>({
		client: villusClient,
		query: MediaPartnerNoticesQuery,
		tags: ['media_partner_notices']
	}).execute();

	return data?.allMediaPartnerNotices[0] ?? null;
}
